<kf-modal>
  <div class="modal-container { state.containerClass }">
    <div class="modal-overlay" onclick="{ () => props.hasOwnProperty('overlayClose') && props.onClose() }"></div>
    <div class="modal-content { typeof props.modal.size == 'string' ? 'mid' : '' }"
      style="{ typeof props.modal.size == 'number' ? 'width: ' + props.modal.size + 'px' : '' }">
      <template if="{ state.show }">
        <slot />
      </template>
    </div>
  </div>

  <script>
    const updateModalOpenCount = (delta) => {
      const body = document.body;
      const count = Math.max(0, Number(body.dataset.kfModalOpenCount || 0) + delta);
      if (count > 0) {
        body.dataset.kfModalOpenCount = String(count);
        body.classList.add('kf-modal-open');
      } else {
        delete body.dataset.kfModalOpenCount;
        body.classList.remove('kf-modal-open');
      }
    };

    export default {
      state: {
        containerClass: '',
        show: false
      },

      onKeyUp(e) {
        const key = e.key || e.code;
        if (key === 'Escape') {
          // this.props.onClose?.();
        }
      },

      // モーダルが開いている場合に Esc を押しても、「遠隔サポート」の警告を表示しないようにする
      onKeyDown(e) {
        const key = e.key || e.code;
        if (key === 'Escape') {
          e.stopPropagation();
          e.preventDefault();
        }
      },

      onBeforeMount(props) {
        this.state.show = !!props.modal.show;
        this.modalOpen = !!props.modal.show;
        if (this.modalOpen) updateModalOpenCount(1);
      },

      onBeforeUpdate(props) {
        const nextModalOpen = !!props.modal.show;
        if (nextModalOpen !== this.modalOpen) {
          updateModalOpenCount(nextModalOpen ? 1 : -1);
          this.modalOpen = nextModalOpen;
        }
        const isShow = this.state.containerClass == 'modal-container-show' || this.state.containerClass == 'modal-show';
        const isNotShow = this.state.containerClass != 'modal-container-show' && this.state.containerClass != 'modal-show';
        if (props.modal.show && isNotShow) {
          this.state.show = !!props.modal.show;
          document.addEventListener('keyup', this.onKeyUp);
          document.addEventListener('keydown', this.onKeyDown);
          if (this.props.preventTransition) {
            this.state.containerClass = 'modal-show';
          } else {
            this.state.containerClass = 'modal-container-show';
          }
          this.$('.modal-content')?.focus();
        } else if (!props.modal.show && isShow) {
          document.removeEventListener('keyup', this.onKeyUp);
          document.removeEventListener('keydown', this.onKeyDown);
          props.onEnd && props.onEnd();
          this.state.show = false;
          this.state.containerClass = '';
        }
      },

      onBeforeUnmount() {
        if (this.modalOpen) updateModalOpenCount(-1);
      }
    };
  </script>

  <style type="postcss">
    .modal-close {
      z-index: 9998;
      font-size: 20px;
      position: absolute;
      right: 0px;
      top: 0px;
      color: #ffffff;
      background-color: transparent;
      border: none;
      width: 42px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    .modal-overlay {
      position: fixed;
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgb(0, 0, 0, 0.15);
    }

    .modal-container {
      display: none;
      flex-direction: column;
      align-items: center;
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      justify-content: center;
    }

    .modal-show,
    .modal-container-show,
    .modal-container-hide {
      display: flex;
    }

    @keyframes modalshow {
      from {
        opacity: 0;
        transform: scale(.87, .87)
      }

      to {
        opacity: 1;
        transform: scale(1, 1);
      }
    }

    @keyframes modalhide {
      from {
        opacity: 1;
        transform: scale(1, 1)
      }

      to {
        opacity: 0;
        transform: scale(.8, .8);
      }
    }

    .modal-container-show > .modal-content {
      animation: modalshow .1s ease-out;
    }

    .modal-container-hide > .modal-content {
      animation: modalhide .1s ease-out;
    }

    .modal-content {
      transition: width ease .2s;
      position: relative;
      z-index: 9999;
      width: 600px;
      max-width: 100%;
      overflow-y: auto;
      max-height: calc(100% - 92px);
      background-color: #ffffff;
      box-shadow: 0 8px 16px 0 rgba(175, 151, 151, 0.2);
      border-radius: 4px;
    }

    .modal-content.large {
      width: 1024px;
    }

    .modal-content.mid {
      width: 640px;
    }

    .modal-content.min {
      width: 480px;
    }
  </style>
</kf-modal>
